import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-estado-planilla',
  templateUrl: './add-estado-planilla.component.html',
  styleUrls: ['./add-estado-planilla.component.css']
})
export class AddEstadoPlanillaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
